import React from "react";
import { Link } from "react-router-dom";
import { LINKS } from "../../lib/constants";

export default function LegalLayout({ title, lastUpdated, children }) {
  return (
    <div className="bg-white pt-12 pb-20" data-testid={`legal-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 lg:px-12">
        <Link to="/" className="text-xs uppercase tracking-[0.18em] text-brand-stone hover:text-brand-black inline-flex items-center gap-1">
          ← Back to home
        </Link>
        <h1 className="font-display text-5xl sm:text-6xl mt-5 leading-[0.95]">{title}</h1>
        <p className="text-xs uppercase tracking-[0.18em] text-brand-stone mt-4">Last updated: {lastUpdated}</p>
        <div className="divider-strong my-7" />
        <div className="legal-prose">{children}</div>

        <div className="mt-14 p-6 bg-brand-yellow border-[1.5px] border-brand-black rounded-2xl">
          <p className="text-sm">
            Questions about this policy? Email{" "}
            <a href={`mailto:${LINKS.email}`} className="font-semibold underline decoration-brand-black decoration-2 underline-offset-2">{LINKS.email}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
